import { useContext, useMemo } from "react";
import ThemeContext from "../ThemeContext/index";
import { useReadingDirections } from "../readingDirections/readingDirections";
import { CarinaContext } from "../../CarinaProvider";
var shmonsole = console;
export function useBuildStyleWithTheme(buildStyle) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, isRtl = ref.isRtl, errorId = ref.errorId, errorStyle = ref.errorStyle, _suppressErrors = ref.suppressErrors, suppressErrors = _suppressErrors === void 0 ? false : _suppressErrors;
    var theme = useContext(ThemeContext);
    var readingDirections = useReadingDirections(isRtl);
    var ref1;
    var ref2 = (ref1 = useContext(CarinaContext)) !== null && ref1 !== void 0 ? ref1 : {}, breakpoints = ref2.breakpoints, flags = ref2.flags;
    return useMemo(function() {
        if (typeof buildStyle === 'function') {
            try {
                return buildStyle(theme, readingDirections, flags !== null && flags !== void 0 ? flags : {}, breakpoints !== null && breakpoints !== void 0 ? breakpoints : {});
            } catch (error) {
                if (!suppressErrors) {
                    shmonsole.error("[useBuildStyleWithTheme".concat(errorId ? ": ".concat(errorId) : '', "] \"buildStyle function has errors. \nThis is likely due to the tokens object given to ThemeProvider not matching the expected shape. Or, the ThemeContext cannot find a ThemeProvider instance in the component tree (Provider and Consumer dependency versions must match).").concat(theme.version ? " Found tokens with version: ".concat(theme.version) : ''), error);
                }
                return errorStyle;
            }
        }
        if (!suppressErrors) {
            shmonsole.error("[useBuildStyleWithTheme".concat(errorId ? ": ".concat(errorId) : '', "] \"buildStyle\" parameter is not a function"));
        }
        return errorStyle;
    }, [
        buildStyle,
        errorId,
        errorStyle,
        readingDirections,
        suppressErrors,
        theme,
        flags,
        breakpoints
    ]);
}
export default useBuildStyleWithTheme;
